import axios from 'axios';

const TIMEOUT = 30000;

class Api {

    static fetchCustomerInfoDocsAsync(info, transactionId) {
        console.debug("Api#fetchCustomerInfoDocsAsync");

        return axios.request({
            method: 'POST',
            headers: {
                'Cache-Control': 'no-cache, no-store',
                Pragma: 'no-cache',
            },
            url: process.env.REACT_APP_CUSTOMER_INFO_DOCS_URL,
            data: {
                ...info,
                transactionId
            },
            timeout: TIMEOUT,
            validateStatus: status => status === 200
        })
            .then(({data}) => {

                if (!Array.isArray(data.documents)) {
                    return [];
                }

                return data.documents.map(document => ({
                    name: document.fileName,
                    url: document.url,
                }));
            });
    }
}

export {Api};